import Styles from './CanaisAtendimentoGolpes.css';
import React from 'react';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function CanaisAtendimentoGolpes() {
  return (
    <>
      <section id="canais-atendimento-golpes">
        <ContainerHome24>
          <div className="content-golpes-gray">
            <h3 className="content-golpes-gray-title">Não caia em golpes!</h3>
            <p className="content-golpes-gray-paragrafo">
              Confira nossas dicas de segurança para contar com todos os nossos serviços de forma
              prática e segura para você.
            </p>
          </div>

          <div className="content-golpes-slider is-mob">
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`canais-slide ${className}`}>
                    <img
                      className="golpe-img"
                      src="assets/canais-de-atendimento/wpp-ola.svg"
                      alt="conversa com santander pelo whatsapp"
                    />
                    <p className="golpe-paragrafo">
                      Para geração de boletos, solicitamos apenas o seu CPF. Lembre-se que o número
                      que você utiliza para conversar com a gente deve ser o mesmo de seu cadastro.
                    </p>
                  </div>

                  <div className={`canais-slide ${className}`}>
                    <img
                      className="golpe-img"
                      src="assets/canais-de-atendimento/wpp-acesso.svg"
                      alt="conversa com santander pelo whatsapp"
                    />
                    <p className="golpe-paragrafo">
                      O selinho verde ao lado do nome indica que esse número foi v erificado e
                      confirma que é o perfil oficial da Santander Financiamentos.
                    </p>
                  </div>

                  <div className={`canais-slide ${className}`}>
                    <img
                      className="golpe-img"
                      src="assets/canais-de-atendimento/wpp-acesso-cnpj.svg"
                      alt="conversa com santander pelo whatsapp"
                    />
                    <p className="golpe-paragrafo">
                      O contato aparece automaticamente como Santander Financiamentos e ao abrir o
                      perfil o CNPJ 07.707.650/001-10 também é apresentado.
                    </p>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="content-golpes is-desk">
            <div>
              <img
                className="golpe-img"
                src="assets/canais-de-atendimento/wpp-ola.svg"
                alt="conversa com santander pelo whatsapp"
              />
              <p className="golpe-paragrafo">
                Para geração de boletos, solicitamos apenas o seu CPF. Lembre-se que o número que
                você utiliza para conversar com a gente deve ser o mesmo de <br /> seu cadastro.
              </p>
            </div>

            <div>
              <img
                className="golpe-img"
                src="assets/canais-de-atendimento/wpp-acesso.svg"
                alt="conversa com santander pelo whatsapp"
              />
              <p className="golpe-paragrafo">
                O selinho verde ao lado do nome indica que esse número foi verificado e confirma que
                é o perfil oficial da Santander Financiamentos.
              </p>
            </div>

            <div>
              <img
                className="golpe-img"
                src="assets/canais-de-atendimento/wpp-acesso-cnpj.svg"
                alt="conversa com santander pelo whatsapp"
              />
              <p className="golpe-paragrafo">
                O contato aparece automaticamente como Santander Financiamentos e <br /> ao abrir o
                perfil o CNPJ
                <br /> 07.707.650/001-10 também
                <br /> é apresentado.
              </p>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CanaisAtendimentoGolpes;
